import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    faq: 'FAQ',
    contractAddress: '{stakedToken} contract address: ',
  },
};
